import { render, staticRenderFns } from "./NotifiToken.vue?vue&type=template&id=912d854e&scoped=true&"
import script from "./NotifiToken.vue?vue&type=script&lang=js&"
export * from "./NotifiToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912d854e",
  null
  
)

export default component.exports